import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import TaskList from "../pages/Task/TaskList";
import TaskKanban from "../pages/Task/TaskKanban";
import ProtectedRouteV2 from "./ProtectedRouteV2";

const taskRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/tasks/list"
      element={
        <>
          <PageTitle title="Task List | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <TaskList />
        </>
      }
    />
    <Route
      path="/tasks/kanban"
      element={
        <>
          <PageTitle title="Task Kanban | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <TaskKanban />
        </>
      }
    />
  </Route>
);

export default taskRoutes;
